import { Injectable, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AuthService } from '../../auth/services/auth.service';
import { InstanceConfigService } from '../../../core/services/instance-config.service';
import { CotizacionService } from './cotizacion.service';

const FINANZAS = ['ROLE_OWNER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];
const ESPERA_MINIMA_MS = 60_000;

/** Borradores de OT que administración debe completar antes de enviarlos. */
@Injectable({ providedIn: 'root' })
export class CotizacionesPorValorarService {
  private readonly cotizaciones = inject(CotizacionService);
  private readonly auth = inject(AuthService);
  private readonly instanceConfig = inject(InstanceConfigService);
  private readonly router = inject(Router);

  private readonly pendientes = signal(0);
  readonly cantidad = this.pendientes.asReadonly();
  private ultimaConsulta = 0;
  private enVuelo = false;

  constructor() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.refrescar());
    effect(() => {
      if (this.instanceConfig.muestraServicioTecnico()) this.refrescar();
    });
    this.refrescar();
  }

  refrescar(forzar = false): void {
    if (!this.puedeConsultar() || this.enVuelo) return;
    const ahora = Date.now();
    if (!forzar && ahora - this.ultimaConsulta < ESPERA_MINIMA_MS) return;

    this.ultimaConsulta = ahora;
    this.enVuelo = true;
    this.cotizaciones.contarBorradoresDeServicio().subscribe({
      next: response => {
        this.enVuelo = false;
        if (response.success && response.data != null) this.pendientes.set(response.data);
      },
      error: () => { this.enVuelo = false; },
    });
  }

  limpiar(): void {
    this.pendientes.set(0);
    this.ultimaConsulta = 0;
  }

  private puedeConsultar(): boolean {
    return this.auth.isAuthenticated()
      && this.auth.hasAnyRole(FINANZAS)
      && this.instanceConfig.muestraServicioTecnico();
  }
}
